import dayjs from 'dayjs';
import { getUser } from '@frontend/auth-helpers';
import { FREE_TRIAL_NUDGE_LOCAL_STORAGE_KEY } from './constants';

type FreeTrialNudgeStorage = {
  dismissCount: number; // how many times user dismissed in current 10-day window
  lastShown: dayjs.Dayjs; // timestamp of the last time banner was shown
};

/**
 * Determines whether the free trial nudge  should be shown
 */
export function shouldShowFreeTrialNudge(): boolean {
  const userId = getUser()?.userID || '';
  if (!userId) return false;

  const now = dayjs();
  const key = `${FREE_TRIAL_NUDGE_LOCAL_STORAGE_KEY}_${userId}`;
  const stored = localStorage.getItem(key);

  const END_DATE = dayjs('2026-04-30'); // After April 2026 there are no free trials

  if (now.isAfter(END_DATE)) {
    return false;
  }

  if (stored) {
    const data = JSON.parse(stored) as FreeTrialNudgeStorage;
    const lastShown = dayjs(data.lastShown);

    // Reset dismiss count if 10-day window has passed since lastShown
    if (now.diff(lastShown, 'day') >= 10) {
      data.dismissCount = 0;
      data.lastShown = now;
      localStorage.setItem(key, JSON.stringify(data));
      return true;
    }

    return data.dismissCount < 3;
  } else {
    const intializeLocalStorageData = { dismissCount: 0, lastShown: now };
    localStorage.setItem(key, JSON.stringify(intializeLocalStorageData));
    return true;
  }
}

/**
 * Call this function when user dismisses the tooltip
 */
export function recordFreetrialNudgeDismiss() {
  const userId = getUser()?.userID || '';
  const key = `${FREE_TRIAL_NUDGE_LOCAL_STORAGE_KEY}_${userId}`;
  const stored = localStorage.getItem(key);
  if (!stored) return;

  const data: FreeTrialNudgeStorage = JSON.parse(stored);
  data.dismissCount += 1;
  data.lastShown = dayjs();
  localStorage.setItem(key, JSON.stringify(data));
}
